import React from 'react';
import styled from 'styled-components';
import Marquee from './ui/Marquee';
import { getTechIcon } from './ui/techIcon';
import { skillGroups, workedWith } from '../data/portfolio';

/**
 * Full-bleed, slightly tilted double marquee band — tech chips scrolling one
 * way, big outlined words scrolling the other.
 */
const Band = styled.div`
  position: relative;
  width: 104vw;
  margin: 4.5rem 0 4.5rem -2vw;
  transform: rotate(-1.6deg);
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  background: var(--surface);
  backdrop-filter: blur(6px);
  padding: 1.4rem 0;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, var(--wash1), transparent 30%, transparent 70%, var(--wash2));
    pointer-events: none;
  }
`;

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.5rem 1.1rem;
  border-radius: 999px;
  border: 1px solid var(--border);
  background: var(--bg-alt);
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 0.95rem;
  color: var(--text);
  white-space: nowrap;
  svg { color: var(--primary-light); font-size: 1.15rem; }
`;

const Big = styled.span`
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: clamp(1.6rem, 3.4vw, 2.4rem);
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
  color: transparent;
  -webkit-text-stroke: 1px var(--text-faint);
  opacity: 0.8;

  &.solid {
    color: var(--text-faint);
    -webkit-text-stroke: 0;
    opacity: 0.55;
  }
`;

const Star = styled.span`
  color: var(--secondary);
  font-size: 1.3rem;
`;

const RowGap = styled.div`
  height: 1.1rem;
`;

const allTech = [...new Set(skillGroups.flatMap((g) => g.items))];
const bigWords = ['Full-Stack', ...workedWith, 'Web & Mobile', 'CI / CD'];

const TechMarquee = () => (
  <Band aria-hidden="true">
    <Marquee duration={34} gap="1rem">
      {allTech.map((t) => (
        <Chip key={t}>{getTechIcon(t)}{t}</Chip>
      ))}
    </Marquee>
    <RowGap />
    <Marquee duration={46} reverse gap="2.2rem">
      {bigWords.map((w, i) => (
        <React.Fragment key={w}>
          <Big className={i % 2 ? 'solid' : ''}>{w}</Big>
          <Star>✦</Star>
        </React.Fragment>
      ))}
    </Marquee>
  </Band>
);

export default TechMarquee;
